/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientFamilyMembers = sqliteTable('patient_family_members', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  patient_id: text('patient_id'),
  related_patient_id: text('related_patient_id'),
  relationship_type: text('relationship_type'),
  relationship_label: text('relationship_label'),
  name: text('name'),
  sex: text('sex'),
  birth_date: text('birth_date'),
  age_text: text('age_text'),
  notes: text('notes'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
  updated_by: text('updated_by'),
});
